import { UnitCost } from "./UnitCost";
import { Unit } from "./Unit";


export interface TeamCost {
    readonly a: UnitCost;
    readonly b: UnitCost;

    readonly maxTeamCost: number;
}


export namespace TeamCost {
    export function getMaxTeamCost(a: Unit, b: Unit): number {
        for (const cost of allTeamCosts) {
            if (cost.a === a.cost && cost.b === b.cost) {
                return cost.maxTeamCost;
            }
        }

        return 0;
    }




    export const allTeamCosts: ReadonlyArray<TeamCost> = [
        { a: UnitCost.cost590, b: UnitCost.cost590, maxTeamCost: 590, },
        { a: UnitCost.cost590, b: UnitCost.cost560, maxTeamCost: 590, },
        { a: UnitCost.cost590, b: UnitCost.cost450, maxTeamCost: 590, },
        { a: UnitCost.cost590, b: UnitCost.cost420, maxTeamCost: 590, },
        { a: UnitCost.cost590, b: UnitCost.cost280, maxTeamCost: 870, },
        { a: UnitCost.cost590, b: UnitCost.cost270, maxTeamCost: 860, },
        { a: UnitCost.cost590, b: UnitCost.cost200, maxTeamCost: 990, },
        { a: UnitCost.cost560, b: UnitCost.cost590, maxTeamCost: 590, },
        { a: UnitCost.cost560, b: UnitCost.cost560, maxTeamCost: 560, },
        { a: UnitCost.cost560, b: UnitCost.cost450, maxTeamCost: 560, },
        { a: UnitCost.cost560, b: UnitCost.cost420, maxTeamCost: 980, },
        { a: UnitCost.cost560, b: UnitCost.cost280, maxTeamCost: 840, },
        { a: UnitCost.cost560, b: UnitCost.cost270, maxTeamCost: 830, },
        { a: UnitCost.cost560, b: UnitCost.cost200, maxTeamCost: 960, },
        { a: UnitCost.cost450, b: UnitCost.cost590, maxTeamCost: 590, },
        { a: UnitCost.cost450, b: UnitCost.cost560, maxTeamCost: 560, },
        { a: UnitCost.cost450, b: UnitCost.cost450, maxTeamCost: 900, },
        { a: UnitCost.cost450, b: UnitCost.cost420, maxTeamCost: 870, },
        { a: UnitCost.cost450, b: UnitCost.cost280, maxTeamCost: 730, },
        { a: UnitCost.cost450, b: UnitCost.cost270, maxTeamCost: 990, },
        { a: UnitCost.cost450, b: UnitCost.cost200, maxTeamCost: 850, },
        { a: UnitCost.cost420, b: UnitCost.cost590, maxTeamCost: 590, },
        { a: UnitCost.cost420, b: UnitCost.cost560, maxTeamCost: 980, },
        { a: UnitCost.cost420, b: UnitCost.cost450, maxTeamCost: 870, },
        { a: UnitCost.cost420, b: UnitCost.cost420, maxTeamCost: 840, },
        { a: UnitCost.cost420, b: UnitCost.cost280, maxTeamCost: 980, },
        { a: UnitCost.cost420, b: UnitCost.cost270, maxTeamCost: 960, },
        { a: UnitCost.cost420, b: UnitCost.cost200, maxTeamCost: 820, },
        { a: UnitCost.cost280, b: UnitCost.cost590, maxTeamCost: 870, },
        { a: UnitCost.cost280, b: UnitCost.cost560, maxTeamCost: 840, },
        { a: UnitCost.cost280, b: UnitCost.cost450, maxTeamCost: 730, },
        { a: UnitCost.cost280, b: UnitCost.cost420, maxTeamCost: 980, },
        { a: UnitCost.cost280, b: UnitCost.cost280, maxTeamCost: 840, },
        { a: UnitCost.cost280, b: UnitCost.cost270, maxTeamCost: 830, },
        { a: UnitCost.cost280, b: UnitCost.cost200, maxTeamCost: 960, },
        { a: UnitCost.cost270, b: UnitCost.cost590, maxTeamCost: 860, },
        { a: UnitCost.cost270, b: UnitCost.cost560, maxTeamCost: 830, },
        { a: UnitCost.cost270, b: UnitCost.cost450, maxTeamCost: 990, },
        { a: UnitCost.cost270, b: UnitCost.cost420, maxTeamCost: 960, },
        { a: UnitCost.cost270, b: UnitCost.cost280, maxTeamCost: 830, },
        { a: UnitCost.cost270, b: UnitCost.cost270, maxTeamCost: 810, },
        { a: UnitCost.cost270, b: UnitCost.cost200, maxTeamCost: 940, },
        { a: UnitCost.cost200, b: UnitCost.cost590, maxTeamCost: 990, },
        { a: UnitCost.cost200, b: UnitCost.cost560, maxTeamCost: 960, },
        { a: UnitCost.cost200, b: UnitCost.cost450, maxTeamCost: 850, },
        { a: UnitCost.cost200, b: UnitCost.cost420, maxTeamCost: 820, },
        { a: UnitCost.cost200, b: UnitCost.cost280, maxTeamCost: 960, },
        { a: UnitCost.cost200, b: UnitCost.cost270, maxTeamCost: 940, },
        { a: UnitCost.cost200, b: UnitCost.cost200, maxTeamCost: 800, },
    ];

}
